/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Vital-type filter for the Bio Vitals page (029 US1) restyled onto the shared
 * pill/toggle style. BP / Sugar / Oxygen / Salt / Water + an "All" toggle. State
 * (which types are ticked) lives in the page; this component is presentational and
 * drives the `types` param. All-unticked = show every type. Accessible: text +
 * checkmark box + aria-pressed, never colour alone.
 *
 * Props:
 *   types      [{ key, label }]
 *   selected   { bp:bool, sugar:bool, ... }
 *   allChecked bool
 *   onToggle   (key) => void
 *   onToggleAll () => void
 */
const Pill = ({ on, label, onClick }) => (
  <button
    type="button"
    className={`bv-pill${on ? ' is-on' : ''}`}
    aria-pressed={on}
    onClick={onClick}
  >
    <span className="bv-pill__box" aria-hidden="true">{on ? '✓' : ''}</span>
    {label}
  </button>
);

const BioVitalsTypeFilter = ({ types = [], selected = {}, allChecked = false, onToggle, onToggleAll }) => (
  <div className="bv-typefilter" data-testid="bv-typefilter" role="group" aria-label="Filter by vital type">
    <span className="bv-typefilter__lbl">Filter by:</span>
    <Pill on={allChecked} label="All" onClick={onToggleAll} />
    <span className="bv-typefilter__sep" aria-hidden="true" />
    {types.map(({ key, label }) => (
      <Pill key={key} on={!!selected[key]} label={label} onClick={() => onToggle(key)} />
    ))}
  </div>
);

export default BioVitalsTypeFilter;
